import { useEffect, useRef, useState } from "react";
import shallowEqual from "fbjs/lib/shallowEqual";

import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { useFormObject } from "../../../Controls/FormObjectProvider";

import { IMultilineState, IMultilineManagerClient } from "./MultilineManager";

export interface IUseMultilineClient {
    client: IMultilineManagerClient;
    multilineState: IMultilineState;
}

export function useMultilineClient<T>(
    bindingPath: AbsoluteResolvedModelPath,
    filteringUniqueId: string,
    selector: (result: IUseMultilineClient) => T
): T {
    const filteringManager = useFormObject().filteringManager;
    const multilineStateManager = filteringManager.getMultilineManager(bindingPath, filteringUniqueId);

    const [result, setResult] = useState<T>(
        selector({
            client: multilineStateManager,
            multilineState: multilineStateManager.getCurrentState(),
        })
    );

    const previousStateRef = useRef<T>(result);
    useEffect(
        () =>
            multilineStateManager.subscribeClient(updatedState => {
                const selectorResult = selector({
                    client: multilineStateManager,
                    multilineState: updatedState,
                });
                if (!shallowEqual(previousStateRef.current, selectorResult)) {
                    setResult(selectorResult);
                }
                previousStateRef.current = selectorResult;
            }),
        [multilineStateManager]
    );

    return result;
}
